import moment from 'moment';
import { TbCalendarClock } from 'react-icons/tb';
import { useRescheduleContext } from '../../../contexts/RescheduleProvider';
import { AppointmentHistory } from '../../../types/history';
import { convertTimeTo24Hrs } from '../../../utils/timeAndDate';

const RescheduleAppointmentAction = ({
  appointmentHistory,
}: {
  appointmentHistory: AppointmentHistory;
}) => {
  // integration of context hooks here
  const { setShowRescheduleModal, setAppointment } = useRescheduleContext();

  // rendering reschedule appointment action component here
  return (
    <div className='flex items-center justify-center'>
      <button
        title={
          +new Date(
            `${moment(appointmentHistory.date, 'DD-MM-YYYY').format(
              'YYYY-MM-DD'
            )} ${convertTimeTo24Hrs(appointmentHistory.start_time)}`
          ) -
            +new Date() <
          0
            ? 'Can Not Reschedule Past Appointment'
            : appointmentHistory.reschedule_limit === 0
            ? 'No Reschedule Limit'
            : appointmentHistory.reschedule_attempts ===
              appointmentHistory.reschedule_limit
            ? 'Reschedule Limit Reached'
            : 'Reschedule Appointment'
        }
        onClick={() => {
          setAppointment(appointmentHistory);
          setShowRescheduleModal(true);
        }}
        className='bg-base-cyan text-base-white rounded-lg p-1 disabled:opacity-50 disabled:cursor-not-allowed hover:opacity-70 active:scale-95 duration-300'
        disabled={
          +new Date(
            `${moment(appointmentHistory.date, 'DD-MM-YYYY').format(
              'YYYY-MM-DD'
            )} ${convertTimeTo24Hrs(appointmentHistory.start_time)}`
          ) -
            +new Date() <
            0 ||
          appointmentHistory.reschedule_limit === 0 ||
          appointmentHistory.reschedule_attempts ===
            appointmentHistory.reschedule_limit
        }
      >
        <TbCalendarClock className='size-5' />
      </button>
    </div>
  );
};

export default RescheduleAppointmentAction;
